import * as React from 'react';
import { skin, OemProps } from 'ui/styles/skin';
import { WarningTriangle } from 'ui/shapes';
import { FadeScale } from 'ui/transitions';
import { compose, withProps, withState, lifecycle } from 'recompose';

import './VideoFailure.css';

export type OwnProps = {
    error: Error | null;
};

export const RawVideoFailure = ({ visible, text, style }: RecomposeProps) =>
    <FadeScale
        visible={ visible }
        duration={ 200 }
        from={ .5 }
        className="abs"
        unmountOnExit={ true }
    >
        <div className="video-failure">
            <WarningTriangle
                width="4em"
                height="4em"
                style={ style }
            />
            <div className="video-failure-text">
                { text }
            </div>
        </div>
    </FadeScale>
;

type RecomposeProps = {
    visible: boolean;
    text: string | null;
    style: React.CSSProperties;
};
type _RecomposeProps = RecomposeProps & {
    _setText: (t: string | null) => void;
};

export const VideoFailure = compose<RecomposeProps, OwnProps>(
    skin,
    withProps(({ error, styles }: OwnProps & OemProps) => ({
        visible: !!error,
        style: {
            fill: styles.Window.color,
        },
    })),
    withState('text', '_setText', ({ error }) => error && error.message),
    lifecycle({
        componentDidUpdate(oldProps: _RecomposeProps & OwnProps) {
            // Update our internal error text if a new error has been set.
            // We do this trickery rather than naively displaying the
            // error message directly because then the error text would
            // disappear suddenly as the error UI fades out (which happens
            // when the error is cleared). This way, the error text fades
            // out with the rest of the UI. Looks much nicer.
            const { error, text, _setText } = this.props;
            if (error && error.message !== text) {
                _setText(error.message);
            }
        },
    })
)(RawVideoFailure);



// WEBPACK FOOTER //
// ./src/ui/pages/monitoring/mainPanel/VideoFailure.tsx